import { render, staticRenderFns } from "./tagsSearch.vue?vue&type=template&id=9a1b5002&scoped=true"
import script from "./tagsSearch.vue?vue&type=script&lang=js"
export * from "./tagsSearch.vue?vue&type=script&lang=js"
import style0 from "./tagsSearch.vue?vue&type=style&index=0&id=9a1b5002&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1b5002",
  null
  
)

export default component.exports